export default {
  name: '8pt Grid',
  value: 8,
  description: 'The ADAPT Design System uses a spacing scale based on increments of 8'
};